import React, { Component } from "react";
import { getGameTitle } from "../../../../../helpers/eventHelpers";
import { getText } from "../../../../../helpers/localization";
import OpenBet from "../../../components/openBet";

class OpenBetTennis extends Component {
  render() {
    let homeTeam =
      this.props.betSelection.bets[0].event.playerOne.split(" ")[1];
    let awayTeam =
      this.props.betSelection.bets[0].event.playerTwo.split(" ")[1];
      let selection = this.props.betSelection.bets[0].market.selection;
    let name;
    // the following switch modify the selection based on market code

    switch (this.props.betSelection.bets[0].market.code) {
      case 218:
        name = this.props.betSelection.bets[0].market.selection.split(" ")[1];
        break;
      case 219:
        name = selection.replace("Player 1", homeTeam).replace("Player 2", awayTeam).replace("To Win", "")
        .trim();
        break;
      case 220:
        name = getText(
          this.props.betSelection.bets[0].market.selection.split(" ")[0],
          this.props.store,
          [this.props.betSelection.bets[0].market.selection.split(" ")[1]]
        );
        break;
      case 221:
        name = this.props.betSelection.bets[0].market.selection;
        break;
      case 222:
        name =
          this.props.betSelection.bets[0].market.num <= 3
            ? homeTeam +
              " " +
              getText(
                selection.replace("Player 1", "").trim(),
                this.props.store
              )
            : awayTeam +
              " " +
              getText(
                selection.replace("Player 2", "").trim(),
                this.props.store
              );
        break;
      default:
        name = getText(
          this.props.betSelection.bets[0].market.selection,
          this.props.store
        );
        break;
    }

    let names = [name];

    let title = `${this.props.betSelection.bets[0].event.playerOne} ${getText(
      "VS",
      this.props.store
    )} ${this.props.betSelection.bets[0].event.playerTwo}`;
    let eventName = getGameTitle(
      title,
      this.props.betSelection.bets[0].event.eventTimeDate,
      this.props.store.getState().vpp.systemLanguage
    );
    let betType = getText(
      this.props.betSelection.bets[0].betType.name,
      this.props.store,
      [homeTeam, awayTeam]
    );
    let odd = this.props.betSelection.bets[0].market.odds;

    return (
      <OpenBet
        store={this.props.store}
        index={this.props.index}
        betSelection={this.props.betSelection}
        names={names}
        betType={betType}
        odd={odd}
        eventName={eventName}
        isEnabled={this.props.isEnabled}
        openBetFocusCallback={this.props.openBetFocusCallback}
      />
    );
  }
}

export default OpenBetTennis;



// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/modules/tennis/components/openBetTennis.js